import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/visitorInvite/index',
    name: 'visitorInviteIndex',
    component: () => import('@/sub-app/visitorInvite/pages/index.vue'),
    meta: {
      title: '访客邀约',
      keepAlive: false,
    },
  },
  {
    path: '/visitorInvite/visitorList',
    name: 'visitorInviteList',
    component: () => import('@/sub-app/visitorInvite/pages/visitorList.vue'),
    meta: {
      title: '访客邀约',
      keepAlive: false,
    },
  },
  {
    path: '/visitorInvite/visitorPass',
    name: 'visitorInviteVisitorPass',
    component: () => import('@/sub-app/visitorInvite/pages/visitorPass.vue'),
    meta: {
      title: '访客邀约',
      keepAlive: true,
    },
  },
  {
    path: '/visitorInvite/faceProtocal',
    name: 'visitorInviteFaceProtocal',
    component: () => import('@/sub-app/visitorInvite/pages/faceProtocal.vue'),
    meta: {
      title: '',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
